import { Btn, Icon, Spinner } from './button.style';

type ButtonProps = {
  text: string;
  icon?: React.ReactNode;
  pad?: string;
  margin?: string;
  borderRadius?: string;
  loading?: boolean;
  loadingText?: string;
  disabled?: boolean;
  handleButton: () => void;
};

const Button: React.FC<ButtonProps> = ({
  text,
  pad,
  margin,
  borderRadius,
  icon,
  loading = false,
  loadingText,
  disabled = false,
  handleButton,
}) => {
  const isDisabled = loading || disabled;

  return (
    <>
      <Btn
        style={{
          padding: `${pad}`,
          margin: `${margin}`,
          borderRadius: `${borderRadius}`,
        }}
        onClick={isDisabled ? undefined : handleButton}
        disabled={isDisabled}
        aria-busy={loading}
      >
        {loading ? <Spinner /> : icon && <Icon>{icon}</Icon>}
        {loading && loadingText ? loadingText : text}
      </Btn>
    </>
  );
};

export default Button;
